import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupLaboratoryApi = {
    getTrialGroupLaboratories: (): Observable<Dtos.GetTrialGroupLaboratoriesResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratories = new Dtos.GetTrialGroupLaboratories();

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoriesByTrialGroupId: (trialGroupId?: number): Observable<Dtos.GetTrialGroupLaboratoriesByTrialGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoriesByTrialGroupId = new Dtos.GetTrialGroupLaboratoriesByTrialGroupId();

        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoriesByTrialGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoriesByTrialId: (trialId?: number): Observable<Dtos.GetTrialGroupLaboratoriesByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoriesByTrialId = new Dtos.GetTrialGroupLaboratoriesByTrialId();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoriesByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoryById: (id: number): Observable<Dtos.GetTrialGroupLaboratoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryById = new Dtos.GetTrialGroupLaboratoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoryByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetTrialGroupLaboratoryByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryByLaboratoryId = new Dtos.GetTrialGroupLaboratoryByLaboratoryId();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupLaboratory: (trialGroupLaboratory: Dtos.TrialGroupLaboratory): Observable<Dtos.SetTrialGroupLaboratoryResponse> => {

        let request: Dtos.SetTrialGroupLaboratory = new Dtos.SetTrialGroupLaboratory();

        request.trialGroupLaboratory = trialGroupLaboratory;

        // send request
        const response: Promise<Dtos.SetTrialGroupLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialGroupLaboratory: (laboratoryId: number | null, trialGroupId: number | null): Observable<Dtos.CreateTrialGroupLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupLaboratory = new Dtos.CreateTrialGroupLaboratory();

        request.laboratoryId = laboratoryId;
        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupLaboratoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteTrialGroupLaboratory: (id: number): Observable<Dtos.DeleteTrialGroupLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.DeleteTrialGroupLaboratory = new Dtos.DeleteTrialGroupLaboratory();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteTrialGroupLaboratoryResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupLaboratory: (trialGroupLaboratory: Dtos.TrialGroupLaboratory): Observable<Dtos.ValidateTrialGroupLaboratoryResponse> => {

        let request: Dtos.ValidateTrialGroupLaboratory = new Dtos.ValidateTrialGroupLaboratory();

        request.trialGroupLaboratory = trialGroupLaboratory;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    }
}